module.exports = __webpack_public_path__ + "img/BOTANA.c26d6f2c.png";